export default __webpack_public_path__ + "static/media/mobile-build-image.411beb81.jpg";